import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { MailOutline } from "@material-ui/icons";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";
import Button from "components/CustomButtons/Button.js";
import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function RemoveAnnouncementBanner(props) {
  const classes = useStyles();
  const { id } = useParams();
  const signal = useRef(new AbortController());

  const [announcement, setAnnouncement] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    bookingApi
      .get("Announcements/" + id, { signal: signal.current.signal })
      .then(setAnnouncement)
      .catch(error => console.log(error));
    return () => signal.current.abort();
  }, [id]);

  const handleRemove = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .delete("Announcements/Banner/" + id, { signal: signal.current.signal })
      .then(() => setRedirect(true))
      .catch(error => {
        if (signal.current.signal.aborted) return;
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/Announcement/List"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>REMOVE BANNER IMAGE</h4>
          </CardHeader>
          <CardBody>
            <p>
              <i>
                *Are you sure you want to remove the banner from this
                announcement? The website will show the default placeholder
                instead.
              </i>
            </p>
            <form onSubmit={handleRemove}>
              <Button onClick={() => props.history.goBack()} value="back">
                BACK
              </Button>
              <Button
                disabled={disabled || !announcement?.banner}
                color="rose"
                type="submit"
                value="Submit"
              >
                REMOVE
              </Button>
            </form>
            {announcement && (
              <div>
                <CustomInput
                  labelText="Title"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: announcement.title ?? "",
                    disabled: true
                  }}
                />
                <CustomInput
                  labelText="Current Banner"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: announcement.banner ?? "No banner",
                    disabled: true
                  }}
                />
                {announcement.banner && (
                  <img
                    src={announcement.banner}
                    alt="Current banner"
                    style={{ maxWidth: 360, maxHeight: 180, borderRadius: 6 }}
                  />
                )}
              </div>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

RemoveAnnouncementBanner.propTypes = {
  history: PropTypes.object
};
